/**
 * wrapper around JQuery.ajax() that will re-queue requests if they failed with a HTTP 401 error (or in older players: 403)
 */
import * as etplayer from "./etplayer"

var _requestsDisabled = false;
var _requestQueue = [] as Request[];

type DoneCallback = (data: any, textStatus: string, jqXHR: JQuery.jqXHR) => any 
type FailCallback = (jqXHR: JQuery.jqXHR, textStatus: JQuery.Ajax.ErrorTextStatus, errorThrown: string) => any;

// Asynchronous API request
class Request {
    options: JQuery.AjaxSettings
    promise: JQueryDeferred<any>

    constructor(options: JQuery.AjaxSettings) {
        this.options = options
        this.promise = $.Deferred();
    }

    run(): this {
        if (_requestsDisabled) {
            // TODO we may not wanna queue POST requests...
            queueRequest(this);
            return this;
        }

        // actually run the request (asynchronously, returning a promise)
        $.ajax(this.options).then((data,_textStatus,_jqXHR) =>{
            this.promise.resolve(data);
        }, (jqXHR, textStatus, errorThrown) => {
            this._onError(jqXHR, textStatus, errorThrown);
        })

        return this;
    }

    private _onError(jqXHR: JQuery.jqXHR, textStatus: JQuery.Ajax.ErrorTextStatus, errorThrown: string) {
        // 2022-08-17: new players use 401 for 'please login' and 403 for 'you're not allowed to do this'
        // older ones use 403 for both - TODO 2024-01-22: remove the 403 variant once we're certain everythings' been updated - etplayer.ErrorMessage() needs to be updated then aswell
        if (jqXHR.status == 401 || jqXHR.status == 403) {
            // Auth error => re-queue the request
            queueRequest(this); // TODO we should not queue POST requests here
            _requestsDisabled = true;
        }
        else {
            this.promise.reject(jqXHR, textStatus, errorThrown);
        }

        new etplayer.ErrorMessage(jqXHR.status, "request failed: "+errorThrown).show();
    }

    //
    // selected promise methods
    //
    done(doneFilter: DoneCallback): Request {
        this.promise.done(doneFilter)
        return this
    }

    then(doneFilter: DoneCallback, failFilter?: FailCallback): Request {
        this.promise.then(doneFilter, failFilter as any);
        return this;
    }

    // helper that will call promise.fail() if this request fails
    failOtherPromise(promise: JQueryDeferred<any>): Request {
        this.promise.fail((jqXHR, textStatus, errorThrown) => {
            promise.reject(jqXHR, textStatus, errorThrown);
        });
        return this;
    }
}

// triggered by #loginForm's onsubmit
function login(ev: JQuery.SubmitEvent) {
    var $userInput = $('#loginUser');
    var $pwdInput = $('#loginPwd');
    var user = $userInput.val();
    var pwd = $pwdInput.val();

    $userInput.val('');
    $pwdInput.val('');

    $.ajax({url: applyBaseURL('/login'), method: 'POST', data: {
        'user': user,
        'pwd': pwd
    }}).done(function(_data) {
        etplayer.hideDialog('#loginDialog');
        $('#loginErr').hide();
        _requestsDisabled = false;
        $('body').removeClass('loggedOut');
        while (_requestQueue.length > 0) {
            let req = _requestQueue.pop();
            if (!req) throw("request queue empty!?!");
            req.run();
        }
    }).fail(function(_jqXHR, _textStatus, _errorThrown) {
        $('#loginErr').show();
    });
    ev.preventDefault();
}

export function post(url: string, data?: JQuery.PlainObject | string, options?: JQuery.AjaxSettings) {
    if (!options) options = {};
    options.url = applyBaseURL(url);
    options.dataType = 'json';
    options.data = data;
    options.method = "POST";
    let rc = new Request(options);
    return rc.run();
}

// adds a request to the queue (will be executed once the user logs in); returns a promise
function queueRequest(req: Request): void {
    if (req.options.url == undefined) throw "missing request URL";
    if (req.options.url.match(/player\/[0-9]+\/info/)) {
        //console.log("Not queueing info request: "+data.url);
        req.promise.reject(undefined, "not logged in", null); //return a rejected promise (i.e. fail() callbacks will be called immediately)
        return;
    }

    _requestQueue.push(req);
}

// runs the given request (or adds it to a queue if the user's not logged in right now); returns a promise
export function request(url: string, data?: JQuery.PlainObject | string | undefined, options?: JQuery.AjaxSettings): Request {
    if (!options) options = {};
    options.url = applyBaseURL(url);
    options.dataType = 'json';
    options.data = data;
    let rc = new Request(options);
    return rc.run();
}

// base URL for API requests (see applyBaseURL())
var _baseURL: string = undefined;

// prepend a prefix to the given URL
// this is used for https://remote.eartunes.at/remote/{device}/
// (i.e. if document.location.path starts with '/remote/.../, prepend that to URL', 
export function applyBaseURL(url: string): string {
    if (_baseURL === undefined) {
        var pattern = /^(\/?[^\/]+\/[^\/]+).*$/g;
        // first time initialization
        // take the first two path segments and prepend them to all future API requests
        if (document.location.pathname.match(pattern)) {
            _baseURL = document.location.pathname.replace(pattern, '$1');
        }
        else _baseURL = null;
    }

    if (_baseURL === null) {
        return url;
    }
    if (!url.startsWith('/')) url = '/'+url;
    var rc = new URL(url, document.location.toString());
    rc.pathname = _baseURL.replace(/\/+$/, '') + '/' + rc.pathname.replace(/^\/+/, '');
    return rc.toString();
}

$(() => {
    $('#loginForm').on('submit', login);
})
